import { defineStore } from "pinia";

export const useCatalogPublicationLanguagesStore = defineStore("CatalogPublicationLanguagesStore", {
  state: () => ({
    data: null,
    loading: false,
  }),
  actions: {
    async fetchCatalogPublicationLanguages(query) {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/languages.json/${query}`);
        this.data = response;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    },
    async fetchLanguage(alpha2) {
      try {
        const response = await this.$axios.get(`language/${alpha2}`);
        return response;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  }
});
